import React, { Component } from 'react';
import { TRANSACTION_TYPE } from '../../../reducer/transaction';
import { formatISODate } from '../../../utils/formatting';
import {
	ChevronDownIcon,
	ChevronUpIcon,
	Container,
	ClosedInfo,
	ProductInfoWrapper,
	ExpandDetailed,
} from './HistoryContainer';

export default class TicketHistory extends Component {
	state = {
		expandDetailed: false,
	}

	chevronIcon = selected => {
		if (selected) {
			return (
				<ChevronUpIcon
					className="svg-icon"
					aria-hidden="true"
					focusable="false"
					alt=""
				/>
			);
		} else {
			return (
				<ChevronDownIcon
					className="svg-icon"
					aria-hidden="true"
					focusable="false"
					alt=""
				/>
			);
		}
	};

	expandDetailedInfo = () => {
		this.setState(state => ({
			expandDetails: !state.expandDetails,
		}));
	};

	getStatusLabel = () => {
		const { transaction, travellerId } = this.props;

		if (transaction.type === TRANSACTION_TYPE.TRANSFER) {
			return 'Överlåten';
		}

		const isLentToCurrentUser = transaction.recipient && transaction.recipient.id === travellerId;
		return isLentToCurrentUser ? 'Lånad' : 'Utlånad';
	}

	render() {
		const { expandDetails } = this.state;
		const { transaction } = this.props;

		const timeStamp = formatISODate(transaction.timestamp);

		return (
			<Container>
				<ClosedInfo>
					<span>{timeStamp}</span>
					<span>{this.getStatusLabel()}</span>
				</ClosedInfo>

				{expandDetails && (
					<ProductInfoWrapper>
						<span>{transaction.description}</span>
					</ProductInfoWrapper>
				)}
				<ExpandDetailed onClick={this.expandDetailedInfo} aria-expanded={expandDetails}>
					{this.chevronIcon(expandDetails)}
				</ExpandDetailed>
			</Container>
		);
	}
}
